<template>
  <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M12.3213 7.50002C12.0254 7.50002 11.7855 7.73986 11.7855 8.03574V13.3928C11.7855 13.6887 11.5457 13.9285 11.2498 13.9285H1.60712C1.31125 13.9285 1.0714 13.6887 1.0714 13.3928V2.67865C1.0714 2.38278 1.31125 2.14294 1.60712 2.14294H8.03561C8.33148 2.14294 8.57132 1.90309 8.57132 1.60722C8.57132 1.31135 8.33148 1.07153 8.03561 1.07153H1.60712C0.719532 1.07153 0 1.79107 0 2.67865V13.3928C0 14.2804 0.719532 14.9999 1.60712 14.9999H11.2499C12.1374 14.9999 12.857 14.2804 12.857 13.3928V8.03571C12.857 7.73986 12.6171 7.50002 12.3213 7.50002Z"
          fill="currentColor"/>
      <path
          d="M14.3998 0.600855C14.0152 0.21615 13.4935 6.77675e-05 12.9495 0.000130546C12.4051 -0.00143891 11.8829 0.21502 11.4993 0.6012L4.44295 7.65697C4.38441 7.71595 4.34025 7.78764 4.31385 7.86643L3.24245 11.0807C3.14894 11.3614 3.3007 11.6647 3.58142 11.7582C3.63588 11.7763 3.69291 11.7856 3.75029 11.7857C3.8078 11.7856 3.86495 11.7763 3.91957 11.7584L7.13382 10.687C7.21276 10.6606 7.28448 10.6162 7.34327 10.5573L14.3996 3.50099C15.2005 2.70019 15.2006 1.40175 14.3998 0.600855Z"
          fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconEdit",
}
</script>